import { Injectable } from "@angular/core";
import { AppService } from "../../../../core/service/Base.Service";


@Injectable()

export class SMMessageService extends AppService<any>{
    constructor() {
        super('SMMessage');
    }

    async getEntityWiseMessages(typeid) {
        var entityid = this.localStorage.get('selectedEntity')

        const data = await this.get('EntityWiseMessages', [entityid, typeid]);
        return data;
    }

    async getMessageLog(msgid) {
        var entityid = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('MessageLog', [entityid, msgid]);
        return data;
    }

    async getSMSLog(msgid) {
        var entityid = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('SMSLog', [entityid, msgid]);
        return data;
    }

    async getTypeWiseMessage(msgtypeid) {
        var entityid = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('TypeWiseMessage', [entityid, msgtypeid]);
        return data;
    }

    async getMessageChart(msgid) {

        var entityid = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('MessageChart', [entityid, msgid]);
        return data;
    }

    async getSMSChart(msgid) {
        var entityid = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('SMSChart', [entityid, msgid]);
        return data;
    }

    async getMessageDeliveredChart(msgid) {
        var entityid = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('MessageDeliveredChart', [entityid, msgid]);
        return data;
    }
    async getMessageInfo(entityid, typeid, fromdate, tilldate) {
        const data = await this.get('EntityWiseMessages', [entityid, typeid, fromdate, tilldate]);
        return data;
    }

    async getMessageNotifications(entityid, msgtypeid, typeid, typerefenceid) {

        let selectedEntity = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('Notifications', [selectedEntity, msgtypeid, typeid, typerefenceid]);
        return data;
    }

    async getCircularNotifications(entityid, msgtypeid, typeid, typerefenceid) {

        let selectedEntity = Number(this.localStorage.get('selectedEntity'))
        const data = await this.get('Notifications', [selectedEntity, msgtypeid, typeid, typerefenceid]);
        return data;

    }

}


// WEBPACK FOOTER //
// ./src/app/shell/forms/Communication/Message/SMMessage.service.ts